import React, { useMemo, useState } from "react";
import { ResultForm } from "./ResultForm";
import { getValue } from "../../utils/object.utils";
import { Modal, ModalSize } from "../Modal";

interface Props {
  //   open: boolean;
  resultDetail: object | null;
  onClose: () => unknown;
  open: boolean;
}

export const EditResultModal = ({ resultDetail, onClose, open }: Props) => {
  const [label, setLabel] = useState(getValue(resultDetail, "code") || "");
  const [code, setCode] = useState(getValue(resultDetail, "code") || "");
  const [publishDate, setPublishDate] = useState(
    getValue(resultDetail, "publishDate")
  );
  const [branchId, setBranchId] = useState(getValue(resultDetail, "branchId"));
  const [classId, setClassId] = useState(getValue(resultDetail, "classId"));

  useMemo(() => {
    const label = getValue(resultDetail, "label");
    const code = getValue(resultDetail, "code");
    const publishDate = getValue(resultDetail, "publishDate");

    setLabel(label);
    setCode(code);
    setPublishDate(publishDate);
  }, [resultDetail]);

  //   const { isLoading: isUpdatingBranch, mutate: updateBranch } = useUpdateBranch(
  //     {
  //       branchId: getValue(resultDetail, "id"),
  //       onSuccess: () => {
  //         dispatch(setSuccessMessage("Successfully updated branch."));
  //         onClose();
  //       },
  //       onError: (error) => {
  //         dispatch(setErrorMessage(parseApiError(error)));
  //       },
  //     }
  //   );

  //   const handleBranchUpdate = () => {
  //     if (
  //       !validateBranchData(
  //         {
  //           branchName: name,
  //           branchAddress: address,
  //           branchEstablished: established,
  //           branchDesc: description,
  //         },
  //         dispatch
  //       )
  //     ) {
  //       return;
  //     }
  //     const formattedDate = formatDateBasedOnTimezone({
  //       date: moment(established, TEXTUAL_DATE_FORMAT),
  //       formatType: "YYYY-MM-DD",
  //     });

  //     updateBranch({
  //       name,
  //       address,
  //       established_in: formattedDate,
  //       description,
  //     });
  //   };

  const handleBranchUpdate = () => {};

  return (
    <Modal
      show={open}
      onClose={onClose}
      modalHeader="Edit result"
      modalSize={ModalSize.sm}
      submissionButton={{
        text: "Save",
        onClick: () => {
          handleBranchUpdate();
        },
        isSubmitLoading: false,
      }}
    >
      <div>
        <ResultForm
          resultLable={label}
          setResultLabel={setLabel}
          resultCode={code}
          setResultCode={setCode}
          schoolBranchId={branchId}
          onBranchSelect={setBranchId}
          selectedClass={classId}
          onClassSelect={setClassId}
          publishDate={publishDate}
          setPublishDate={setPublishDate}
        />
      </div>
    </Modal>
  );
};
